import { PublicKey } from "@solana/web3.js";
import { makeDSTProgram } from "./makeDSTProgram.js";
import { Provider } from "@coral-xyz/anchor";

export function initDirector({
  dst,
  operator,
  payer,
  director,
  provider,
}: {
  provider?: Provider;
  dst: PublicKey;
  operator: PublicKey;
  payer: PublicKey;
  director: PublicKey;
}) {
  const program = makeDSTProgram(provider);

  const result = program.methods.initDirector().accountsPartial({
    dst,
    operator,
    payer,
    director,
  });
  /*
    .preInstructions([
        SystemProgram.createAccount({
            fromPubkey: operator,
            newAccountPubkey: director,
            lamports: await connection.getMinimumBalanceForRentExemption(
                program.account.director.size
            ),
            space: directorAccountSize,
            programId: new PublicKey('DStkUE3DjxBhVwEGNzv89eni1p7LpYuHSxxm1foggbEv'),
          })
    ]);
    */

  return result;
}
